import { updateLastMessage } from '@/composables/chat/actions/attendances'
import { useChatMessages } from '@/stores/chat/messages'
import { useChatAttendance } from '@/stores/chat/attendances'
import { useUsersStore } from '@/stores/users'
import { useChatStore } from '@/stores/chat'
import { useFavicon } from '@vueuse/core'

import newMessage from '@/assets/images/icons/newMessage.svg'
import logo_compact from '@/assets/images/logos/logo_compact.svg'

import { sendWebSocketMessage } from '@/composables/chat/useWebSocket'
import { notify } from '@kyvg/vue3-notification'

import useChat from '@/composables/chat/useChat'

import audioFile from '@/assets/audio/notification.ogg'

const storeMessages = useChatMessages()
const storeChat = useChatStore()
const storeAttendances = useChatAttendance()

const userStore = useUsersStore
/**
 * @param {Object} input
 */
const receiveMessage = (input) => {


    const messages = input.data.messages ?? []

    if (messages.length === 0) return console.warn('[chat] No messages received')

    messages.forEach(message => {
        updateLastMessage(
            message.attendance_id,
            message.attendance_step,
            message,
        )

        storeMessages().receiveMessage(message.attendance_id, message)


        if (storeMessages().arrivedState.bottom) {
            setTimeout(() => {
                // TODO: Check if attendance is active
                // TODO: Check if scroll is at bottom
                useChat.scrollToBottom()
            }, 1)
        }
    })

    const isOwnMessage = input.data.messages[0]?.submitted_by_user == userStore().me?.id
        || input.data.send_by == userStore().me?.id


    if (isOwnMessage) return


    if(input.data.messages[0].attendance.user_id && storeAttendances().currentAttendance?.id != input.data.messages[0].attendance.id){
        if(input.data.messages[0].attendance.user_id == userStore().me?.id ){

            storeChat().newMessagesCount++;

            if(storeChat().soundAlert){
                var audio = new Audio(audioFile);
                audio.play();
            }

         }
    }


    if(input.data.messages[0]?.attendance?.user_id == userStore().me?.id){
        let interval
        if(!storeChat().focused){
            var current = 0;
            var icons = [newMessage, logo_compact];

            interval = setInterval(() => {
                var icon = (++current % icons.length);
                var url = icons[icon];

                useFavicon(url)
            }, 500);
        }

        setInterval(()=>{

            if(storeChat().focused){
                clearInterval(interval)
                useFavicon(logo_compact)
            }

        }, 1)

    }


    if(!window.location.pathname.includes(input.data.messages[0].attendance.id)){


     if(!storeMessages().newMessagesCount[input.data.messages[0].attendance.id]){
        storeMessages().newMessagesCount[input.data.messages[0].attendance.id] = 0
     }
      storeMessages().newMessagesCount[input.data.messages[0].attendance.id]++
    }

}

const updateAck = (acks) => {

  

    acks.forEach(message => {
         if(storeMessages().messages[message.attendance_id]){

           
            const index = storeMessages().messages[message.attendance_id].findIndex(el => el.id ===  Number(message.id))

          
            if(index && storeMessages().messages[message.attendance_id][index]?.ack){
                 
                storeMessages().messages[message.attendance_id][index].ack = message?.ack
            }

         }
    })
}

const deleteMessage = (message)=> {


    console.log(message)

    const index = storeMessages().messages[message.attendance_id].findIndex(el => el.uuid === message.uuid)
    storeMessages().messages[message.attendance_id][index].deleted = true;



      sendWebSocketMessage({
        "type": "chat",
        "action": "delete",
        "data": {
           "message_id": message.uuid, // ID da mensagem
           "requested":  userStore().me?.id, // ID do usuário logado
           "attendance": message.attendance_id // ID do atendimento
        }
     })

     notify({
        type: 'success',
        title: 'Pronto',
        text: 'Mensagem excluída com sucesso',
    })

}

const markAsDeleted = (data, targetUuid) => {

   const attendanceId = data.attendance_id;
   storeMessages().messages[attendanceId].forEach(message => {
    if(message.uuid === targetUuid){

        message.deleted = true;
        
    }
    });

}

//PRIVATE

export default {
    receiveMessage, deleteMessage, updateAck, markAsDeleted
}
